import { createContext } from "react";

const BusinessAccountContext = createContext();

export default BusinessAccountContext;
